<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p v-if="tabs === 'users'">ContentId Users</p>
          <p v-if="tabs === 'asset_labels'">
            Asset Labels - On YT Studio: {{stats.asset_labels_on_yt}} - All: {{stats.all_asset_labels}}
          </p>
          <div class="float-right">
            <span v-if="tabs === 'users'">
              <Filters />
              <el-tooltip content="Insert" placement="top">
                <el-button
                    type="success"
                    circle
                    icon="el-icon-check"
                    @click.prevent="insert()"
                    class="ml10"
                ></el-button>
              </el-tooltip>
            </span>
            <span v-if="tabs === 'asset_labels'">
              <el-tag type="success" style="margin-right: 15px">Last updated: {{stats.last_change | datetime}}</el-tag>
              <el-tooltip content="Sync with youtube studio" placement="top">
                <el-button
                    type="success"
                    circle
                    icon="el-icon-refresh"
                    @click.prevent="syncAssetLabels()"
                    class="mr20"
                ></el-button>
              </el-tooltip>
              <AssetLabelFilters />

            </span>
          </div>
        </div>
        <el-tabs type="border-card"  @tab-click="tabClick" v-model="tabs">
          <el-tab-pane label="Users" name="users">
            <Table />
            <Dialog />
          </el-tab-pane>
          <el-tab-pane label="Asset Labels" name="asset_labels">
            <AssetLabelsTable />
            <AssetLabelDialog />
            <SyncDialog />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '../components/youtube/users/Filters'
import AssetLabelFilters from "../components/youtube/users/AssetLabelFilters.vue";
import Table from '../components/youtube/users/Table'
import Dialog from '../components/youtube/users/Dialog'
import {mapState, mapMutations, mapActions} from 'vuex'
import AssetLabelDialog from "@/modules/admin/cms/components/youtube/users/AssetLabelDialog.vue";
import AssetLabelsTable from "@/modules/admin/cms/components/youtube/users/AssetLabelsTable.vue";
import SyncDialog from "@/modules/admin/cms/components/youtube/users/SyncDialog.vue";

export default {
  components: {
    AssetLabelsTable,
    AssetLabelDialog,
    Filters,
    AssetLabelFilters,
    SyncDialog,
    Table,
    Dialog,
  },
  data() {
    return {
      tabs: 'users'
    }
  },

  computed: {
    ...mapState('youtubeUsers', ['loading', 'asset_label_list', "stats"])
  },

  methods: {
    ...mapActions('youtubeUsers', ['read', "listAssetLabels", 'syncAssetLabels']),
    ...mapMutations('youtubeUsers', ['setDialog', "setAssetLabelDialog", 'setSelectedUser', "setSelectedAssetLabel", "setPage", "setPageSize"]),
    insert() {
      this.setSelectedUser({})
      this.setDialog(true)
    },
    tabClick(tab){
      this.setPageSize(10)
      this.setPage(1)
      if(tab.name === 'users') {
        this.read()
      }
      else {
        this.listAssetLabels()
      }
    }
  }
}
</script>
